import React, { createContext, useContext } from 'react'
import { Form } from 'antd'
import { last, startCase } from 'lodash-es'

type FieldName = React.ComponentProps<typeof Form.Item>['name']

export type AntdFormFieldProps = React.ComponentProps<typeof Form.Item> & {
  noCol?: boolean
  span?: number
  noLabel?: boolean
  afterLabel?: React.ReactNode
  fieldPrefix?: FieldName
}

export type AntdFormItemProps = {
  fieldProps: AntdFormFieldProps
}

export const nameToLabel = (name: string | string[]): string => {
  if (typeof name === 'string') {
    return startCase(last(name.split('.')) || name)
  }
  if (Array.isArray(name)) {
    return nameToLabel(last(name || []) || '')
  }
  return name
}

type AntdFormItemContextProps = {
  fieldPrefix?: React.ComponentProps<typeof Form.Item>['name']
}

export const AntdFormItemContext = createContext<AntdFormItemContextProps>({})
export const useAntdFormItemContext = (name: FieldName) => {
  const { fieldPrefix } = useContext(AntdFormItemContext) || {}
  const finalName = [
    ...(fieldPrefix != undefined ? (Array.isArray(fieldPrefix) ? fieldPrefix : [fieldPrefix]) : []),
    ...(Array.isArray(name) ? name : [name]),
  ]

  return {
    finalName,
  }
}
export const AntdFormItem: React.FC<AntdFormItemProps['fieldProps']> = ({
  afterLabel,
  noLabel = false,
  ...rest
}) => {
  // use native context API to avoid warning about missing provider, as provider is optional
  const { finalName } = useAntdFormItemContext(rest.name as FieldName)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const label = rest.label == undefined ? nameToLabel(rest.name as any) : rest.label

  return <Form.Item
    {...rest}
    label={noLabel ? undefined : <>{label}{afterLabel}</>}
    name={finalName}
  />
}